import RecoverFlow from "./recover-flow";
import {BRC_RECOVER_TYPE} from "./utils/recover_consts";
import ErrorStep from "./steps/error/error";
import TypeStep from "./steps/type";
import StartRunbookWarning from "./steps/start_runbook_warning";
import SetVirtualizationRunbook from "./steps/setup/set_virtualization_runbook";
import CreateRunbookFailover from "./steps/create/create_runbook_failover";
import SetRunbookVirtualizationType from "./steps/setup/set_runbook_virtualization_type";
import RevokeMount from "./steps/revoke_mount";
import ExportVmFailover from "./steps/export/export_vm_failover";
import SetVmExportFailover from "./steps/setup/set_vm_export_failover";
import ExportChangeFormat from "./steps/export/export_change_format";
import ExportVm from "./steps/export/export_vm";
import ExposeCifsShare from "./steps/expose_cifs_share";
import GenericError from "./steps/error/generic_error";
import ApplianceOffline from "./steps/appliance_offline";
import NotAvailable from "./steps/not_available";
import VmRunning from "./steps/vm_running";
import StartVm from "./steps/start_vm";
import ShowVmExist from "./steps/show_vm_exist";
import SetupLocalVm from "./steps/setup_local_vm";
import BrowseLocalVms from "./steps/browse/browse_local_vms";
import Restore from "./steps/restore";
import Browse from "./steps/browse/browse";
import SetRecoveryPoint from "./steps/setup/set_recovery_point";
import SetDrive from "./steps/setup/set_drive";
import SetJob from "./steps/setup/set_job";
import SetDevice from "./steps/setup/set_device";
import SetAppliance from "./steps/setup/set_appliance";
import ConductD2cBmr from "./steps/conduct_d2c_bmr";
import CreateFailoverFailed from "./steps/create/create_failover_failed";
import CreateFailover from "./steps/create/create_failover";
import SetVirtualizationFailover from "./steps/setup/set_virtualization_failover";
import ShowVoExist from "./steps/show_vo_exist";
import SetExportType from "./steps/setup/set_export_type";
import SetVirtualizationType from "./steps/setup/set_virtualization_type";
import LocateVirtualization from "./steps/locate_virtualization";
import RestoreType from "./steps/restore_type";
import SetVoVmsAutoStop from "./steps/setup/set_vo_vms_autostop";

const RECOVER_TYPE = BRC_RECOVER_TYPE;

class Gen2RecoverFlow extends RecoverFlow {
    constructor(context, closeCallback) {
        super(context, closeCallback, RECOVER_TYPE);
        this.defaultStartStep = 'type';
    }

    initializeSteps() {
        this.steps = {
            error: new ErrorStep(),
            type: new TypeStep(),
            startRunbookWarning: new StartRunbookWarning(),
            setVirtualizationRunbook: new SetVirtualizationRunbook(),
            createRunbookFailover: new CreateRunbookFailover(),
            setRunbookVirtualizationType: new SetRunbookVirtualizationType(),
            revokeMount: new RevokeMount(),
            exportVmFailover: new ExportVmFailover(),
            setVmExportFailover: new SetVmExportFailover(),
            exportChangeFormat: new ExportChangeFormat(),
            exportVm: new ExportVm(),
            exposeCifsShare: new ExposeCifsShare(),
            genericError: new GenericError(),
            applianceOffline: new ApplianceOffline(),
            notAvailable: new NotAvailable(),
            vmRunning: new VmRunning(),
            startVm: new StartVm(),
            showVMExist: new ShowVmExist(),
            setupLocalVm: new SetupLocalVm(),
            browseLocalVms: new BrowseLocalVms(),
            restore: new Restore(),
            browse: new Browse(),
            setRecoveryPoint: new SetRecoveryPoint(),
            setDrive: new SetDrive(),
            setJob: new SetJob(),
            setDevice: new SetDevice(),
            setAppliance: new SetAppliance(),
            conductD2cBmr: new ConductD2cBmr(),
            createFailoverFailed: new CreateFailoverFailed(),
            createFailover: new CreateFailover(),
            setVirtualizationFailover: new SetVirtualizationFailover(),
            showVOExist: new ShowVoExist(),
            setExportType: new SetExportType(),
            setVirtualizationType: new SetVirtualizationType(),
            locateVirtualization: new LocateVirtualization(),
            restoreType: new RestoreType(),
            setVoVmsAutoStop: new SetVoVmsAutoStop()
        }
    }
}

const runGen2RecoverFlow = (context, closeCallback) => {
    new Gen2RecoverFlow(context, closeCallback).runFlow();
};


export {
    runGen2RecoverFlow
};
